import React, { useState } from "react";
import copyIcon from "../assets/copy.png";
import telegramIcon from "../assets/telegram.png";
import twitterIcon from "../assets/x.png";
import potuslogo from "../assets/potuslogo.png";
import MusicPlayer from "./MusicPlayer";
import "./Navbar.css";

function Navbar() {
  const [copied, setCopied] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const walletAddress = "31A3vQnQJ5ERbSzsWup2S1jscCYuZgBQk45s3rktpump";

  const handleCopy = () => {
    navigator.clipboard.writeText(walletAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button className="hamburger" onClick={toggleMenu}>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>

        <div className="navbar-logo">
          <img src={potuslogo} alt="POTUS Logo" className="nav-logo" />
        </div>

        {/* Desktop Menu */}
        <div className="desktop-menu">
          <div className="wallet-section">
            <div className="wallet-label">
              <span className="ca-label">CA:</span>
              <span className="wallet-address">{walletAddress}</span>
            </div>
            <button className="copy-button" onClick={handleCopy}>
              <img src={copyIcon} alt="Copy" className="icon" />
              {copied && <span className="copied-tooltip">Copied!</span>}
            </button>
          </div>
          <div className="social-links">
            <MusicPlayer className="nav-music-player" />
            <a href="https://t.me/potus2025sol" target="_blank" rel="noopener noreferrer">
              <img src={telegramIcon} alt="Telegram" className="icon" />
            </a>
            <a href="https://x.com/potus2025sol" target="_blank" rel="noopener noreferrer">
              <img src={twitterIcon} alt="Twitter" className="icon" />
            </a>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
          <div className="wallet-section">
            <div className="wallet-label">
              <span className="ca-label">CA:</span>
              <span className="wallet-address">{walletAddress}</span>
            </div>
            <button className="copy-button" onClick={handleCopy}>
              <img src={copyIcon} alt="Copy" className="icon" />
              {copied && <span className="copied-tooltip">Copied!</span>}
            </button>
          </div>
          <div className="social-links">
            <MusicPlayer className="nav-music-player" />
            <a href="https://t.me/potus2025sol" target="_blank" rel="noopener noreferrer">
              <img src={telegramIcon} alt="Telegram" className="icon" />
            </a>
            <a href="https://x.com/potus2025sol" target="_blank" rel="noopener noreferrer">
              <img src={twitterIcon} alt="Twitter" className="icon" />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
